import { apiRequest } from "@portal/lib/ky/utils";
import { Comment_UI_DTO, CommentDTO } from "@portal/types/entities/comment";

const activities = ["payments", "credit-memos", "disputes", "ptps"] as const;
export type Activity = (typeof activities)[number];
export async function getActivityComment(activity: Activity, params?: string) {
  const data = await apiRequest<unknown, Array<Comment_UI_DTO>>({
    method: "GET",
    url: `v1/${activity}/${params?.toString()}/comments`,
  });
  return await data.json();
}

export async function postActivityComment(
  activity: Activity,
  params: CommentDTO,
  id?: string
) {
  const data = await apiRequest<CommentDTO, Comment_UI_DTO>({
    method: "POST",
    url: `v1/${activity}/${id?.toString()}/comments`,
    data: { ...params },
  });
  return await data.json();
}
